export default {
  notfound: { is: 'Ekkert fannst', en: 'No results' },
};
